// src/internal/components/two-factor-panel/with-twofactor-render.tsx
import * as React from "react";
import { useAuthContext } from "@clara/auth";
import { runIfFn } from "@clara/utils";
import { jsx } from "react/jsx-runtime";
function WithTwofactorRender({
  children: childrenProp,
  ...rest
}) {
  const { twoFactorAuthentication: props } = useAuthContext();
  const children = runIfFn(childrenProp, { ...props, ...rest });
  return /* @__PURE__ */ jsx(React.Fragment, { children });
}

export {
  WithTwofactorRender
};
